import { BreadCrumbPremium } from 'app/components/BreadCrumbPremium';
import LoadPanel from 'app/components/LoadPanel';
import PopupConfirmWithRef from 'app/components/PopupCommon/PopupConfirmWithRef/PopupConfirmWithRef';
import useAxios from 'axios-hooks';
import { CONSTANT, LANG_DEFAULT } from 'constant';
import { Form, Template } from 'devextreme-react';
import React, { useEffect, useRef, useState } from 'react';
import { notification } from 'utils/notification';
import LabelTextTemplate from 'app/components/Templates/LabelTextTemplate';
import { restrictKeyboardPhone } from 'utils/common/restrict-keyboard-phone';
import useDictionary from 'hooks/useDictionary';
import { WrapContent } from 'app/components/WrapContent';
import { requiredMessage } from 'utils/messages';
// import AvatarUploadTemplate from 'app/components/Templates/AvatarUploadTemplate';

const SupperAminProfile = () => {
  const { t }: any = useDictionary({ programId: 'supper-admin-profile' });
  const formRef: any = useRef(null);
  const confirmSaveRef: any = useRef(null);
  const { listPhone } = CONSTANT;
  const [formData, setFormData] = useState<any>({
    userEmail: '',
    userFullNm: '',
    phoneCode: '',
    userPhone: '',
    // mobileCode: '',
    // userMobile: '',
  });

  const [{ loading }, refetchData] = useAxios(
    {},
    { manual: true, autoCancel: true, useCache: false },
  );

  /**
   * Get data detail
   *
   */
  useEffect(() => {
    const getDetail = async () => {
      const res = await refetchData({
        url: `/user-manager/get-supper-admin-profile`,
        method: 'GET',
      });
      if (res?.data?.status === '200') {
        const index = 5;
        const resData = res?.data?.data || {};
        const phoneCode = resData?.userPhone?.slice(0, index) || '';
        const userPhone =
          resData?.userPhone?.slice(index, resData?.userPhone?.length) || '';
        // const mobileCode = resData?.userMobile?.slice(0, index) || '';
        // const userMobile =
        //   resData?.userMobile?.slice(index, resData?.userMobile?.length) || '';

        setFormData({
          ...resData,
          phoneCode,
          userPhone,
          // mobileCode,
          // userMobile,
        });
      } else {
        notification({ res });
      }
    };
    getDetail();
  }, []);
  /**
   * Validate save
   *
   * @return {*}
   */
  const validateSave = () => {
    const isValid = formRef?.current?.instance?.validate?.()?.isValid;
    if (!isValid) return;
    confirmSaveRef?.current?.onOpen?.();
  };

  const onSave = async () => {
    const isValid = formRef?.current?.instance?.validate()?.isValid;
    if (!isValid) return;
    const lang =
      JSON.parse(localStorage.getItem('myPagePreference') ?? '{}')?.language ??
      LANG_DEFAULT;
    const dataRequest = {
      ...formData,
      lang,
      userPhone: formData?.userPhone
        ? formData?.phoneCode + formData?.userPhone
        : '',
    };
    const res = await refetchData({
      url: '/user-manager/update-profile-supper-admin',
      method: 'PUT',
      data: dataRequest,
    });
    notification({ res });
  };

  return (
    <WrapContent>
      <React.Suspense fallback={<LoadPanel visible={true} />}>
        <LoadPanel visible={loading} />
        <BreadCrumbPremium
          title={t('My Profile')}
          subTitle={t(
            'Please fill all the required information to edit the profile.',
          )}
          onSubmit={() => validateSave()}
        />
        <div
          style={{
            marginTop: 10,
            background: '#fff',
            borderRadius: 6,
            height: 'calc(100vh - 150px)',
          }}
        >
          <div style={{ paddingLeft: 30, paddingRight: 20 }}>
            <LabelTextTemplate
              title={t('General Information')}
              subTitle={t('Set up an overview information about user')}
              height={80}
              titleColor="#7F56D9"
              fontSizeTitle={18}
            />
          </div>
          <div className="line-div"></div>
          <div
            style={{ display: 'flex', justifyContent: 'center', marginTop: 20 }}
          >
            <div
              style={{
                width: '40%',
                minWidth: 600,
                paddingLeft: 30,
                paddingRight: 20,
              }}
            >
              <Form
                formData={formData}
                ref={formRef}
                showColonAfterLabel={false}
                labelLocation="top"
                className="form-label-bold"
                colCount={1}
                items={[
                  // {
                  //   itemType: 'simple',
                  //   template: 'avatarUploadTemplate',
                  // },
                  {
                    itemType: 'group',
                    colCount: 1,
                    items: [
                      {
                        label: { text: t('ID') },
                        dataField: 'userId',
                        editorType: 'dxTextBox',
                        editorOptions: {
                          disabled: true,
                        },
                      },
                      {
                        label: { text: t('User Name') },
                        dataField: 'loginId',
                        editorType: 'dxTextBox',
                        validationRules: [
                          { type: 'stringLength', max: 50 },
                          { type: 'required' },
                        ],
                        editorOptions: {
                          inputAttr: { autoComplete: 'off' },
                          disabled: true,
                        },
                      },
                      {
                        label: { text: t('Full Name') },
                        dataField: 'userFullNm',
                        editorType: 'dxTextBox',
                        validationRules: [
                          { type: 'stringLength', max: 256 },
                          {
                            type: 'required',
                            message: requiredMessage(t('Full Name')),
                          },
                        ],
                        editorOptions: {
                          inputAttr: { autoComplete: 'off' },
                        },
                      },
                    ],
                  },
                  {
                    itemType: 'group',
                    colCount: 1,
                    caption: ' ',
                    items: [
                      {
                        itemType: 'simple',
                        template: 'contactInformation',
                        colSpan: 2,
                      },
                      {
                        itemType: 'group',
                        colCount: 3,
                        items: [
                          {
                            dataField: 'phoneCode',
                            editorType: 'dxSelectBox',
                            label: {
                              text: t('Phone No'),
                            },
                            editorOptions: {
                              displayExpr: 'label',
                              valueExpr: 'value',
                              items: listPhone,
                            },
                          },
                          {
                            dataField: 'userPhone',
                            editorType: 'dxTextBox',
                            colSpan: 2,
                            label: {
                              text: t('Phone Number'),
                            },
                            editorOptions: {
                              onKeyDown: restrictKeyboardPhone,
                            },
                          },
                        ],
                      },
                      {
                        label: { text: t('E-mail') },
                        dataField: 'userEmail',
                        editorType: 'dxTextBox',
                        editorOptions: {
                          mode: 'email',
                          inputAttr: { autoComplete: 'off' },
                        },
                        validationRules: [
                          { type: 'email' },
                          {
                            type: 'required',
                            message: requiredMessage(t('E-mail')),
                          },
                        ],
                      },
                    ],
                  },
                ]}
              >
                {/* <Template
              name="avatarUploadTemplate"
              component={() => (
                <AvatarUploadTemplate
                  title={t('Avatar')}
                  subTitle={t('Supported .PNG, .JPEG format and size <5MB')}
                  imgTitle={t('Upoad Image')}
                  height={90}
                  fontSizeTitle={16}
                />
              )}
            /> */}
                <Template
                  name="contactInformation"
                  component={() => (
                    <LabelTextTemplate
                      title={t('Contact Information')}
                      height={40}
                      fontSizeTitle={16}
                    />
                  )}
                />
              </Form>
            </div>
          </div>
        </div>
        <PopupConfirmWithRef
          ref={confirmSaveRef}
          content={'Are you sure to save?'}
          isTranslate
          onOk={onSave}
        />
      </React.Suspense>
    </WrapContent>
  );
};

export default SupperAminProfile;
